import axios from 'axios';

export default {
  getForms() {
    return axios.get('/modules/forms/');
  },
  getReportImage(filename, checksum) {
    return axios({ method: 'get', url: `/medias/forms/report/${filename}/${checksum}`, responseType: 'blob' });
  },
};
